export enum IndicadoresDITypes {
  INDICADORES_GATEWAY = "INDICADORES_GATEWAY",
  SHORTCUT_INDICADORES_HANDLER = "SHORTCUT_INDICADORES_HANDLER",
  KPI_HTTP_GATEWAY = "KPI_HTTP_GATEWAY",
  INDICADORES_PARAMS = "INDICADORES_PARAMS",
  ANTECIPA_CONTRATACAO_GATEWAY = "ANTECIPA_CONTRATACAO_GATEWAY",
  INTERESSES_GATEWAY = "INTERESSES_GATEWAY"
}
